import $ from 'jquery';
import { saveNewBackgroundTags } from '../backgroundTags/saveNewBackgroundTags';
import { showSidebarTab } from '~src/sidebarLegacy';
import { getState } from '~src/state';
import { handleSidebarBackgrounds, handleSidebarImages } from '~src/sidebar';

export const onclickSaveTagsBackground = async (event) => {
  const sidebarCurrentBackgroundTagItemId = $(event.currentTarget).data(
    'save-tag-background-id'
  );
  const selectedTags = $('#tagBackgroundSelect').val();
  const sidebarCurrentStatusTag = $(event.currentTarget).data(
    'save-background-tag-status'
  );

  await saveNewBackgroundTags(
    sidebarCurrentBackgroundTagItemId,
    selectedTags,
    sidebarCurrentStatusTag
  );

  const parentTab = getState('currentSidebarTab');
  if (parentTab) {
    showSidebarTab(parentTab);
    if (parentTab === 'manifesti') {
      await handleSidebarBackgrounds(true);
    } else if (parentTab === 'immagini') {
      await handleSidebarImages(true);
    }
  }
};
